export default {
  manageProvidersHeader: 'Tiekėjų Valdymas',
  providerName: 'Tiekėjo Pavadinimas',
  providerStatus: 'Tiekėjo Statusas',
  providerCreatedSuccess: '{provider} buvo sėkmingai sukurtas.',
  createNewProvider: 'Pridėti Naują Tiekėją',
  active: 'Aktyvus',
  inactive: 'Neaktyvus',
  deactivateProvider: 'Deaktyvuoti Tiekėją',
  deactivateProviderMessage: 'Ar tikrai norite deaktyvuoti tiekėją?',
  noChangesTooltip: 'Nėra pakeitimų, kuriuos reikėtų išsaugoti.',
};
